import script from "./ClientAddCounterpartyDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientAddCounterpartyDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./ClientAddCounterpartyDropdown.vue?vue&type=style&index=0&id=1cc31ed8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cc31ed8"]])

export default __exports__